import type { MetricRecord } from "./MetricRecord";

/**
 * The most recently published record in `records`, or `undefined` when empty. A
 * leaf folds every record sharing its name; the table and the detail card both
 * surface this single newest record's value, timestamp, and attribution.
 */
export function latestRecord(
  records: MetricRecord[],
): MetricRecord | undefined {
  if (records.length === 0) {
    return undefined;
  }
  let best = records[0];
  for (let i = 1; i < records.length; i++) {
    if (records[i].published > best.published) {
      best = records[i];
    }
  }
  return best;
}
